module.exports = __webpack_public_path__ + "static/media/whatsapp.40c18f35.png";